import { render, staticRenderFns } from "./deposit-list-type.vue?vue&type=template&id=7a966d32&scoped=true&"
import script from "./deposit-list-type.vue?vue&type=script&lang=js&"
export * from "./deposit-list-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a966d32",
  null
  
)

export default component.exports